export const isConversationNotificationMuted = (
  settings,
  accountId,
  conversationId
) => {
  const ids = settings?.muted_conversations?.[String(accountId)];
  return (
    Array.isArray(ids) && ids.some(id => Number(id) === Number(conversationId))
  );
};
